import { apiClient } from "helpers/api_helper";

export const getPolicy = async () => {
  const res = await apiClient.get("/api/v1/StorePolicy/GetActiveStorePolicy");
  return res.data; 
};

export const updatePolicy = async (payload: {
  returnDays: number;
  exchangeDay: number;
  buyBackDays: number;

}) => {
  const response = await apiClient.post("/api/v1/StorePolicy/UpdateStorePolicy", payload);
  return response;
};
